import { render, staticRenderFns } from "./GPSNotificationList.vue?vue&type=template&id=c5bd9c84&"
import script from "./GPSNotificationList.vue?vue&type=script&lang=js&"
export * from "./GPSNotificationList.vue?vue&type=script&lang=js&"
import style0 from "./GPSNotificationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports